import moment from 'moment';

export const getAddressTypeInNorwegian = key => {
    if (key === 'home') return 'Hjemmeadresse';
    if (key === 'shipping') return 'Leveringsadresse';
    if (key === 'installation') return 'Installasjonsadresse';
    return key;
};

export const formatPrice = price => {
    const formatter = price => new Intl.NumberFormat('nb-no', {
        maximumFractionDigits: 0,
    }).format(price);

    return `${formatter(price)},-`;
}

export const createPriceLabel = (price, type) => {
    if (type === 'onceOff' && !price.isRecurring) return formatPrice(price.onceOff);
    if (type === 'subscription' && price.isRecurring) return formatPrice(price.subscription);

    return '';
};

export const utcToDisplayDate = date => date ? moment.utc(date).format('DD.MM.YYYY') : '';
export const utcToDisplayDateAndHour = date => date ? moment.utc(date).format('DD.MM.YYYY hh:mm') : '';

export const displayDateToUtc = date => date ? moment.utc(date, "DD.MM.YYYY").format() : '';

export const displayDateToShortDate = date => moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD');
